export default __webpack_public_path__ + "static/media/following-11.e43ddf15.svg";